export default (context, payload) => {
	console.info('🎬 setErrorState', payload);
	context.commit('SET_ERROR', payload);
};
